import { formatCompanyDate } from './companyDateFormat';

/** Parse YYYY-MM-DD as local date (no UTC shift). */
export function parseLocalDate(ymd: string): Date {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/** Format Date as YYYY-MM-DD in local time (avoid toISOString() UTC shift). */
export function toLocalDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export const formatRangeDate = (date: Date) => formatCompanyDate(date);

export function normalizeFreqName(name: string): string {
  return (name || '').trim().toLowerCase();
}

/**
 * Hourly 29–28 cycle containing asOf: 29th of prior month → 28th of current month
 * (when day &lt; 29); if day ≥ 29, cycle ends on the 28th of next month.
 */
export function getOohHourlyCycleContaining(asOf: Date): { start: string; end: string } {
  const d = new Date(asOf.getFullYear(), asOf.getMonth(), asOf.getDate());
  let endYear = d.getFullYear();
  let endMonth = d.getMonth(); // 0-based
  if (d.getDate() >= 29) {
    endMonth += 1;
    if (endMonth > 11) {
      endMonth = 0;
      endYear += 1;
    }
  }
  const end = new Date(endYear, endMonth, 28);
  const start = new Date(end.getFullYear(), end.getMonth() - 1, 29);
  return { start: toLocalDateString(start), end: toLocalDateString(end) };
}

/** Period end from inclusive start, for Weekly / Fortnightly / Monthly / Hourly 29–28. */
export function getPeriodEndForKind(
  startYmd: string,
  kind: 'weekly' | 'monthly' | 'fortnightly' | 'ooh-hourly'
): string {
  const d = parseLocalDate(startYmd);
  if (kind === 'ooh-hourly') {
    return getOohHourlyCycleContaining(d).end;
  }
  if (kind === 'monthly') {
    const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    return toLocalDateString(lastDay);
  }
  if (kind === 'fortnightly') {
    d.setDate(d.getDate() + 13);
    return toLocalDateString(d);
  }
  d.setDate(d.getDate() + 6);
  return toLocalDateString(d);
}
